var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 11.6667L16.6667 14.4167C16.9001 14.6547 16.9692 15.0091 16.8422 15.3174C16.7153 15.6257 16.4167 15.8286 16.0833 15.8333H3.91668C3.58329 15.8286 3.28478 15.6257 3.15782 15.3174C3.03087 15.0091 3.09992 14.6547 3.33335 14.4167L5.83335 11.6667H5.58335C5.24995 11.662 4.95144 11.459 4.82449 11.1507C4.69754 10.8424 4.76658 10.4881 5.00002 10.25L7.50002 7.5H7.33335C6.98468 7.53145 6.65353 7.34163 6.50446 7.02487C6.3554 6.7081 6.42021 6.33195 6.66668 6.08333L10 2.5L13.3333 6.08333C13.5798 6.33195 13.6446 6.7081 13.4956 7.02487C13.3465 7.34163 13.0154 7.53145 12.6667 7.5H12.5L15 10.25C15.2334 10.4881 15.3025 10.8424 15.1755 11.1507C15.0486 11.459 14.7501 11.662 14.4167 11.6667H14.1667M10 18.3333V15.8333",
    stroke: "#165B3D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree);
export default __webpack_public_path__ + "static/media/tree.94c583a7affd48633cd09061d42a2dae.svg";
export { ForwardRef as ReactComponent };